import { BreadcrumbComponent, Button, CIActionGuard, CIPageHeader, ConfirmationPopup, useUserPermission } from 'ccs-ui-components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import DropdownMenuButton from '../../../common/components/UI/menu/DropdownMenuButton';
import { requiredAuthPermission } from '../../../common/constants/UserPermissionConstants';
import { REGISTRY_TYPE } from '../../../dashboard/constants/CommonConstants';
import { STATUS_TYPES } from '../../constants';
import classes from './RegistryHeader.module.scss';

interface IRegistryHeaderProps {
  headerTitle: string;
  onCreateHandler: () => void;
  path: string;
  disableCreate: boolean;
  view: boolean;
  edit: boolean;
  onUpdateHandler: () => void;
  editBtnClickHandler: () => void;
  confirmDialogMsg: string;
  isCreateClicked: boolean;
  isShowPopUp: boolean;
  onDeleteSuccess?: () => void
}

const RegistryHeader = (props: IRegistryHeaderProps) => {
  const [isSticky, setIsSticky] = useState(false);
  const { headerTitle, onCreateHandler, path, disableCreate, view, edit, onUpdateHandler, editBtnClickHandler, confirmDialogMsg, isShowPopUp, isCreateClicked, onDeleteSuccess = undefined } = props;
  const { sourcename, version } = useParams();
  const history = useNavigate();
  const route = useLocation();
  const { t: translate } = useTranslation();
  const { permissionObject } = useUserPermission();

  const onCancelHandler = () => {
    const locationUrl = path;
    history({ pathname: locationUrl, search: route.state ? route.state.path : '' });
  };

  const onBackHandler = () => {
    const locationUrl = path;
    history({ pathname: locationUrl, search: route.state ? route.state.path : '' });
  };

  useEffect(() => {
    const windowScrollStickyHeader = () => {
      const sticky = 10;
      if (window.scrollY > sticky) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener('scroll', windowScrollStickyHeader);

    return (() => {
      window.removeEventListener('scroll', windowScrollStickyHeader);
    });
  }, [translate]);

  return (
    <div className={classes['ci-header']}>
      {(((!isCreateClicked && isShowPopUp) && !view) || route.state?.edit) && <ConfirmationPopup message={confirmDialogMsg} />}
      <BreadcrumbComponent isPreview={view || edit} />
      <div className={`${classes['registry-header-wrapper']} ${isSticky ? classes['sticky-registry-header'] : ''}`}>
        <div className={classes['registry-title-wrapper']}>
          <CIPageHeader header={headerTitle} className={`${isSticky ? classes['sticky-header-title'] : classes['registry-header-title']}`} />
        </div>
        <div className={classes['registry-btn-container']}>
          {(!view && !edit) && (
            <div className={`${classes['registry-btn-wrapper']} ci-button-group`}>
              <Button variant="secondary" onClick={onCancelHandler} data-testid="sr-new-src-cancel-btn">
                {translate('registry_header.btn_cancel')}
              </Button>
              {CIActionGuard([requiredAuthPermission.CP.edit], permissionObject.permission) && (
                <Button className={classes['create-update-btn-gap']} onClick={onCreateHandler} disabled={disableCreate} data-testid="sr-new-src-create-btn">
                  {translate('registry_header.btn_create')}
                </Button>)}
            </div>)}
          {view && !edit && CIActionGuard([requiredAuthPermission.CP.edit], permissionObject.permission)
            && (
              <div className={`${classes['registry-btn-wrapper']} ci-button-group`}>
                <Button variant="secondary" onClick={onBackHandler} data-testid="sr-new-src-back-btn">
                  {translate('registry_header.btn_back')}
                </Button>
                <Button className={classes['registry-edit-btn']} data-testid="sr-new-src-edit-btn" onClick={editBtnClickHandler}>
                  {translate('registry_header.btn_edit')}
                </Button>
                <DropdownMenuButton status={STATUS_TYPES.ACTIVE} deleteURL={`sources/${sourcename}/version/${version}`} onDeleteSuccess={onDeleteSuccess} registryType={REGISTRY_TYPE.SOURCE} />
              </div>
            )}
          {edit && (
            <div className={`${classes['registry-btn-wrapper']} ci-button-group`}>
              <Button variant="secondary" onClick={onCancelHandler} data-testid="sr-new-src-cancel-btn">
                {translate('registry_header.btn_cancel')}
              </Button>
              <Button className={classes['create-update-btn-gap']} onClick={onUpdateHandler} disabled={disableCreate} data-testid="sr-new-src-update-btn">
                {translate('registry_header.btn_update')}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default RegistryHeader;
